var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PlatDataPanelUniformExam',{attrs:{"custom-id":_vm.customId},scopedSlots:_vm._u([{key:"default",fn:function({batchId}){return [(batchId)?[_c('keep-alive',[_c('ExamUniformStudentScoreWrap',{key:batchId,attrs:{"batch-id":batchId}})],1)]:_vm._e()]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }